module.exports = __webpack_public_path__ + "static/media/Star_Icon.c81660a6.png";